import React from "react";

// upColor/downColor let callers color each arrow independently (e.g. to highlight the active sort direction); both default to `color`
export default function OrderArrow({ color = "#CCCCCC", upColor, downColor, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={style}
    >
      <mask
        id="mask0_925_331"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={color} />
      </mask>
      <g mask="url(#mask0_925_331)">
        <path
          d="M8 13V5.825L5.425 8.4L4 7L9 2L14 7L12.575 8.4L10 5.825V13H8Z"
          fill={upColor || color}
        />
        <path
          d="M15 22L10 17L11.425 15.6L14 18.175V11H16V18.175L18.575 15.6L20 17L15 22Z"
          fill={downColor || color}
        />
      </g>
    </svg>
  );
}
